import { notificationTimestamp } from "./notificationPresentation.mjs";

export const INBOX_NOTIFICATION_LIMIT = 50;

export function sortInboxItems(items = []) {
  return items.slice().sort(
    (left, right) =>
      notificationTimestamp(right.createdAt) -
      notificationTimestamp(left.createdAt)
  );
}

export function filterInboxItemsForPortal(items = [], allowedHubSlugSet = null) {
  if (!allowedHubSlugSet || typeof allowedHubSlugSet.has !== "function") {
    return items;
  }
  return items.filter((item) => allowedHubSlugSet.has(item.hubSlug));
}

export function findFreshUnreadItems(
  previousItems = [],
  nextItems = [],
  initialized = false
) {
  if (!initialized) return [];

  const previousTimestamps = new Map(
    previousItems.map((item) => [item.id, notificationTimestamp(item.createdAt)])
  );
  return sortInboxItems(
    nextItems.filter((item) => {
      if (item.read || !item.id) return false;
      const previousTimestamp = previousTimestamps.get(item.id);
      return previousTimestamp === undefined ||
        notificationTimestamp(item.createdAt) > previousTimestamp;
    })
  );
}
